import { AppRole } from '../types/auth';
import { fieldPermissionService } from '../services/auth/fieldPermissionService';
import { getFormStepIdToSections } from '../config/stepSectionMap';

/* eslint-disable security/detect-object-injection -- step ids come from buildDetailFormSteps / stepSectionMap only */

/**
 * Mirrors Request Detail basic mode: non–partner-contributor step visibility uses Requestor @ DRAFT
 * (see useStepVisibility).
 */
export async function isStepHiddenForBasicRequestor(stepId: string): Promise<boolean> {
  if (stepId === 'summary') {
    return false;
  }
  const sections = getFormStepIdToSections()[stepId];
  if (!sections?.length) {
    return false;
  }
  for (const section of sections) {
    const hasAccess = await fieldPermissionService.hasSectionAccess(
      [AppRole.REQUESTOR],
      section,
      'DRAFT',
    );
    if (hasAccess) {
      return false;
    }
  }
  return true;
}

/**
 * When switching to Basic, if the current step is hidden for Requestor @ DRAFT, pick the nearest
 * earlier step that is still visible; if none, the first visible step in nav order.
 */
export async function findRedirectStepIdWhenSwitchingToBasic(
  orderedStepIds: readonly string[],
  currentStepId: string,
): Promise<string | undefined> {
  if (!(await isStepHiddenForBasicRequestor(currentStepId))) {
    return undefined;
  }
  const idx = orderedStepIds.indexOf(currentStepId);
  if (idx < 0) {
    return undefined;
  }
  for (let i = idx - 1; i >= 0; i--) {
    const id = orderedStepIds[i];
    if (!(await isStepHiddenForBasicRequestor(id))) {
      return id;
    }
  }
  for (let i = 0; i < orderedStepIds.length; i++) {
    const id = orderedStepIds[i];
    if (!(await isStepHiddenForBasicRequestor(id))) {
      return id;
    }
  }
  return undefined;
}
